import HeaderSwitchBanner from './HeaderSwitchBanner';

export default HeaderSwitchBanner;
